<template>
  <div>
    <v-row dense>
      <v-col cols='12'>
        <v-text-field
          label='Project name'
          v-model='value.name'
          :rules='[rules.required]'
        ></v-text-field>
      </v-col>
      <v-col cols='12' class='mb-4' v-if='value.division_obj.division === "Construction"'>
        <v-text-field
          label='Project Number'
          v-model='value.number'
          :rules='[rules.required]'
          hint='currently editable for construction projects only'
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <table width='100%'>
          <tr>
            <td>
              <v-text-field
                label='Site address'
                :rules='[rules.required]'
                v-model='value.site_address'
              ></v-text-field>
            </td>
            <td class='text-right' v-if='value.owner_obj'>
              <v-tooltip left>
                <template v-slot:activator='{ on }'>
                  <div v-on='on' class='d-inline-block'>
                    <v-btn icon color='info' :disabled='!value.owner_obj.address' @click='useOwnerAddress'>
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>
                  {{ value.owner_obj.address ? "User owner's address" : "Owner's address is not set"}}
                </span>
              </v-tooltip>
            </td>
          </tr>
        </table>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Site city'
          v-model='value.site_city'
          :rules='[rules.required]'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='Site province'
          v-model='value.site_province'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <wc-postal-code-input
          label='Site postal code'
          v-model='value.site_postal_code'
        ></wc-postal-code-input>
      </v-col>
      <v-col cols='12' md='6' v-if='value.division_obj.division !== "Construction"'>
        <v-text-field
          label='Latitude'
          v-model='value.lat'
          maxlength='20'
          counter
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6' v-if='value.division_obj.division !== "Construction"'>
        <v-text-field
          label='Longitude'
          v-model='value.lng'
          maxlength='20'
          counter
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6' v-if='value.division_obj.division !== "Construction"'>
        <v-text-field
          label='Route group'
          v-model='value.route_group'
          :rules='[geoRules.uppercase]'
          disabled
          hint='Change on project routing page'
          persistent-hint
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6' v-if='value.division_obj.division !== "Construction"'>
        <v-text-field
          label='Route number'
          v-model='value.route_number'
          :rules='[rules.intOrEmpty]'
          disabled
          hint='Change on project routing page'
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'project-basics-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
  computed: {
    geoRules() {
      return {
        uppercase: (value) => {
          const pattern = /^[A-Z]{1,2}$|^null$|^(?![\s\S])/  // this is changed now to 1 or 2 uppercase letters (or empty)
          return pattern.test(value) || 'Uppercase (or empty)'
        },
      }
    }
  },
  methods: {
    useOwnerAddress () {
      this.$emit('useOwnerAddress')
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
